module.exports = __webpack_public_path__ + "static/media/pizza logo.fbdba6d0.png";